

























import { Component, Vue } from 'vue-property-decorator'
import HelloWorld from '@/components/HelloWorld.vue' // @ is an alias to /src

@Component({
  components: {
    HelloWorld,
  },
})
export default class Home extends Vue {
    private land: boolean = false
    private landingButton: string = ''
    private changeTopMargin: boolean = false
    private toPlayPage () {
        console.log('--')
        // if (this.$wjh.parseQuery(window.location.href).d) {
        //     window.location.href = 'https://www.heartide.com/statics/redirect?url=630'
        //     return
        //     if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
        //         this.$parent.tips_toggle = true
        //         return
        //     }
        //     const type = this.$root.configData.type === 'catch' ? 1 : 2
        //     let url = location.href.split('#')[0]
        //     if (location.href.split('#')[0].includes('?')) {
        //         url += '&'
        //     } else {
        //         url += '?'
        //     }
        //     window.location.href = `cosleep://deeplink?code=1053url=${url}activity_type=${type}`
        //     setTimeout(() => {
        //         window.location.href = 'https://www.heartide.com/statics/redirect?url=630'
        //     }, 2000)
        //     return
        // }
        this.$router.push('./playing')
    }
    private mounted () {
        this.$parent.showDown = true && !this.$root.cosSleep
        this.$root.test()
        // if (this.$wjh.parseQuery(window.location.href).d) {
        //     this.land = true
        // }
        // console.log(window.innerHeight / window.innerWidth)
        if ((window.innerHeight / window.innerWidth) > 1.7) {
            this.changeTopMargin = true
        }
        if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
            // @ts-ignore
            this.$root.share.weiXinInit(this.url)
            // @ts-ignore
            this.$root.share.weatherCode()
            // @ts-ignore
            this.$root.share.weiXinGetName(this.url)
        }
    }
}
